export const getIsAuthenticated = (state) => state.auth.identityAuthenticated;
export const getSignInErrors = (state) => state.auth.signInErrors;
export const getSignInSubmitting = (state) => state.auth.signInSubmitting;
